import whatsapp from './channels/whatsapp';

const channel = {
  whatsapp
};

export default channel;
